var footerData = {
    subtitle_1:"Créé avec React.js",
    subtitle_2:"Developpement et Design par Edouard Mignien",
}

exports.footerData = footerData